import React, { FunctionComponent, ReactNode } from 'react';
import Typography from '../Typography';
import Button, { ButtonSizes } from '../Button';

type ConfirmationPromptProps = {
  isLoading: boolean;
  message: ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
};

const ConfirmationPrompt: FunctionComponent<ConfirmationPromptProps> = ({
  isLoading,
  message,
  onCancel,
  onConfirm,
}) => (
  <>
    <Typography>{message}</Typography>
    <div className="mba-actions">
      <Button onClick={onCancel} text="Cancel" size={ButtonSizes.big} />
      <Button onClick={onConfirm} primary text="Confirm" isLoading={isLoading} size={ButtonSizes.big} />
    </div>
  </>
);

export default ConfirmationPrompt;
